import { OPTIONS_ADVERTISEMENTS_PORTALS } from '@wiggot/utils/src/advertisements-portals'

export const PORTAL_IDS_WITH_OPTIONS = ['I24', 'ALLPROPERTY', 'M3']

export const PORTAL_IDS_ASSIGNED_OPTIONS = ['VIVANUNCIOS', 'LAMUDI']

export const PORTALS_WITH_OPTIONS = [
  ...PORTAL_IDS_WITH_OPTIONS,
  ...PORTAL_IDS_ASSIGNED_OPTIONS
]

export const assignedAdvertisementByPortalId: {
  [key: string]: {
    name: string
    id: string
  }[]
} = {
  I24: OPTIONS_ADVERTISEMENTS_PORTALS.I24,
  M3: OPTIONS_ADVERTISEMENTS_PORTALS.M3,
  VIVANUNCIOS: OPTIONS_ADVERTISEMENTS_PORTALS.VIVANUNCIOS,
  ALLPROPERTY: OPTIONS_ADVERTISEMENTS_PORTALS.ALLPROPERTY,
  LAMUDI: OPTIONS_ADVERTISEMENTS_PORTALS.LAMUDI
} as const

export const assignedListAdOptionIdByPortalId: { [key: string]: string } = {
  I24: 'i24',
  M3: 'm3',
  VIVANUNCIOS: 'vivanuncios',
  ALLPROPERTY: 'allproperty',
  LAMUDI: 'lamudi'
} as const
